import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RippleModule } from 'primeng/ripple';
import { ButtonModule } from 'primeng/button';
import { LOGIN_FAILED_LOOP_REASON } from '../auth-redirect-loop-breaker';

@Component({
  selector: 'app-login-failed',
  templateUrl: './login-failed.component.html',
  styleUrls: ['./login-failed.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RippleModule, ButtonModule],
})
export class LoginFailedComponent {
  /** Set when the redirect loop breaker stopped the sign-in (see auth-redirect-loop-breaker.ts). */
  readonly loopDetected = inject(ActivatedRoute).snapshot.queryParamMap.get('reason') === LOGIN_FAILED_LOOP_REASON;
}
